import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';

const pageData = {
  seo: {
    title: 'Home Services Business Software & Booking Systems | RojrzTech',
    description: 'Transform your home services business with custom job booking portals, real-time dispatch, automatic invoicing, and local SEO services from RojrzTech.',
  },
  hero: {
    badge: 'HOME SERVICES SOLUTIONS',
    slides: [
      {
        heading: { pre: 'Streamline Your', gold: 'Home Services', post: 'Operations' },
        subheading: 'We build custom booking apps, real-time technician dispatch trackers, and invoice management tools that scale plumbing, electrical, HVAC, and cleaning businesses.',
        pills: ['Booking Portal', 'Tech Dispatch', 'Invoicing Tools', 'Customer CRM', 'Stripe POS'],
        image: '/hs.jpeg',
      },
      {
        heading: { pre: 'Instant Job Scheduling &', gold: 'Technician Tracking' },
        subheading: 'Let clients schedule emergency repairs or routine tune-ups directly from your website. Keep technicians dispatched efficiently with real-time location logs.',
        pills: ['Real-time Dispatch', 'Calendar Booking', 'Technician Tracker', 'SMS Status Alerts', 'Google Map Api'],
        image: '/hs1.jpeg',
      },
      {
        heading: { pre: 'Professional Quotes &', gold: 'Digital Invoicing' },
        subheading: 'Generate professional quotes on-site, collect digital client signatures, and receive payments instantly with integrated Stripe/Square mobile POS modules.',
        pills: ['On-site Quotes', 'E-Signatures', 'Stripe/Square SDK', 'Auto Reciept', 'Profit Logs'],
        image: '/hs.jpeg',
      },
    ],
  },
  showcase: {
    phoneTitle: 'SERVICE SCHEDULER',
    phoneSubtitle: 'Book a technician and trace job progress in real-time.',
    tags: [
      { title: 'Automated Job Assign', desc: 'Instantly assign new bookings to the nearest available technician automatically.' },
      { title: 'Local Search Lead Flow', desc: 'Rank top-3 locally for high-intent search keywords like "emergency plumber".' },
      { title: 'Automated Status Alerts', desc: 'Keep clients in the loop with auto-generated technician ETA alerts and updates.' },
      { title: 'Interactive Booking Calendar', desc: 'Allow customers to select convenient 2-hour window appointments dynamically.' },
      { title: 'Mobile Invoicing Portal', desc: 'Technicians can generate invoices and charge cards directly on their phones.' },
      { title: 'Customer Feedback Collection', desc: 'Trigger automated post-job text reviews to build your Google Maps rating.' },
    ],
  },
  videoSection: {
    title: 'Service Dispatch Console Demo',
    subtitle: 'See how our centralised booking dashboard connects customer requests to dispatched technicians in real-time.',
    frameLabel: 'TECHNICIAN SERVICE DASHBOARD',
  },
  cards: {
    title: 'Custom Systems Tailored for Home Services',
    subtitle: 'We eliminate manual phone scheduling chaos by building digital portals that capture client details and receive payments automatically.',
    items: [
      {
        icon: '🏠',
        title: 'Customer Booking Portal',
        description: 'An interactive multi-step booking widget for your website that lets clients select service categories, view prices, and secure appointment slots.',
      },
      {
        icon: '⚡',
        title: 'Technician Mobile App',
        description: 'Provide your field staff with a lightweight application displaying task details, navigation routes, customer notes, and invoicing tools.',
      },
      {
        icon: '📊',
        title: 'Centralised Admin CRM',
        description: 'A comprehensive control console to trace active jobs, edit technician schedules, manage inventory, and audit revenue trends.',
      },
    ],
  },
  features: {
    title: 'All-In-One Home Service App Features',
    subtitle: 'Maximize efficiency, optimize technician routing, and boost reviews with features built for local service leaders.',
    items: [
      'Multi-Step Booking',
      'Real-time Technician GPS',
      'Instant SMS Status Updates',
      'Digital Estimates / Quotes',
      'On-site Card Swipes',
      'Technician Shift Logs',
      'Customer History CRM',
      'Google Review Triggers',
      'Route Optimization Map',
      'Digital Contract Sign',
      'Service Price Matrix',
      'Tech Availability Calendar',
    ],
  },
};

const HomeServices = () => {
  return <IndustryPageTemplate pageData={pageData} />;
};

export default HomeServices;
